export default __webpack_public_path__ + "static/0314-573f59c28b7c5e15ecc4fb164b15a0f0.png";